export default __webpack_public_path__ + "static/lovefreund-white-3455ea890573d2f2182e571d0290a73d.png";